/* eslint-disable no-duplicate-imports, no-unused-vars, array-callback-return, react-hooks/exhaustive-deps */
import React, { useState, useEffect, useMemo, useCallback, useContext, useRef } from "react";
import { CircularProgress, Drawer, Chip, Box, Tooltip } from "@mui/material";
import { styled } from '@mui/material/styles';
import { SelectedAlertsContext } from "../../../utils/SelectedAlertContext";
import Multiselectwithsearchinput from "../../components/dropdown/MultiSelectWithInput";
import { exportExcelFile } from "../../api/api";
import { getActionSummary } from "../../api/actionSummary";
import { underLyingExportData } from "../../api/underlyingExportData"
import { ListItem } from "@mui/material";
import SnackBarMessage from "../../components/snackbar/snackbar";
import ExportLoader from "../../components/snackbar/exportLoader";
import AlertRmpmKpi from "../../components/Cards/AlertKPI";
import ReviewCart from "./reviewCart";
import ActionPopup from "../../../Samarth Module/components/popup/actionPopup";
import Filters from "../../../assets/images/filters.svg";
import Excel from "../../../assets/images/Excel.svg";
import Slider from "../../../assets/images/sliders 1.svg";
import CustomiseColumns from "../../../Samarth Module/components/drawers/CustomiseColumns";
import MoreFilters from "../../../Samarth Module/components/drawers/moreFilters";
import { getAlertConfig } from "../../constants/alertConfig";
import CustomButton from "../../components/buttons/CustomButton";
import ActionSummaryPopup from "../../components/popup/actionSummaryPopup"
import styles from "./alert.module.css";
import PropTypes from 'prop-types';
import clsx from 'clsx';
import resetBtn from "../../../assets/images/resetBtn.png";
import EyeOpen from "../../../assets/images/eyeOpen.svg";
import EyeClose from "../../../assets/images/eyeClose.svg";
import OverflowMenu from "Samarth Module/components/overflowMenu/OverflowMenu";
import { useMsal } from "@azure/msal-react";
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import ChatBot from '../../components/chatbot/ChatBot';
import { transformFilters } from "utils/transformFilters";
import { scheduleCleanup, getFilterDetails } from "utils/generateFilterObject";
import HistoryIcon from '@mui/icons-material/History';
import { usePageTracking } from "utils/userPageTracking";
import { useRefresh } from "utils/refreshContext";

// Move styled component outside component to prevent recreation
export const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  '& .MuiToggleButtonGroup-grouped': {
    fontSize: "12px",
    fontWeight: 400,
    padding: "3px 5px",
    textTransform: "none",
    width: "9rem",
    color: "#2B2B2B",
    '&:hover': {
      background: "transparent",
    }
  },
  '& .MuiToggleButtonGroup-grouped.Mui-selected': {
    background: "#1F36C7",
    color: "white",
    '&:hover': {
      background: "#1F36C7",
      color: "white"
    }
  }
}));

// Constants
const CONTEXT_ALERT_TYPES = ['RMPM Alert', 'Agile OR', 'Norm Alert', 'Contract Alert', 'Contract PR2 Alert', 'FG Coverage'];
const INITIAL_PAGINATION = {
  page: 1,
  per_page: 25,
  total: 0
};
const CONTRACT_ALERT_MRP_DEFAULT_TYPES = new Set(['Contract Alert', 'Contract PR2 Alert']);
const CONTRACT_ALERT_MRP_FILTER_LABEL = 'MRP Type';
const CONTRACT_ALERT_MRP_EXCLUDED_OPTIONS = new Set(['ND', 'Z0']);
const pages = ["Detailed", "Detailed view", "MAI View", "Open PO Details",'Contract Alert','Contract PR2 Alert'];

const getTableBodyClass = (alertType, viewType) => {
  if (alertType === 'Contract Alert') return styles.rmpmTableBodyC;
  if (viewType.includes('Detailed')) return styles.rmpmTableBodyD;
  return styles.rmpmTableBody;
};

const getContainerClass = (viewType, uiConfig) => clsx(
  viewType.includes('MAI') ? styles.rmpmContainermai : styles.rmpmContainer,
  {
    [styles.fullHeight]: uiConfig.containerClass === 'fullHeight',
    [styles.fullHeightContract]: uiConfig.containerClass === 'fullHeightContract',
    [styles.fullHeightWeekly]: uiConfig.containerClass === 'fullHeightWeekly',
    [styles.fullHeightNorm]: uiConfig.containerClass === 'fullHeightNorm',
    [styles.fullHeightSupplierInsights]: uiConfig.containerClass === 'fullHeightSupplierInsights',
    [styles.fullHeightFgCoverage]: uiConfig.containerClass === 'fullHeightFgCoverage',
  }
);

const buildFilterChips = (filters, onFilterChange) => {
  const chips = [];

  (filters || []).forEach((filter) => {
    if (filter.isFavourite || !Array.isArray(filter.selectedData) || filter.selectedData.length === 0) {
      return;
    }

    filter.selectedData.forEach((selectedValue, subIndex) => {
      chips.push({
        key: `${filter.label}-${selectedValue}-${subIndex}`,
        label: selectedValue,
        onDelete: () => onFilterChange(
          filter.label,
          filter.selectedData.filter((_, index) => index !== subIndex)
        )
      });
    });
  });

  return chips;
};

const getCustomizeType = (viewType, alertType) => {
  if (viewType === 'MAI View') return 'MAI';
  if (viewType === 'Open PO Details') return 'OpenPO Details';
  if (viewType === 'Stock to Norm') return 'Norm Alert';
  if (viewType === 'FG Coverage') return viewType;
  return alertType;
};

const hasSelectedValues = (selectedData) => {
  if (Array.isArray(selectedData)) {
    return selectedData.length > 0;
  }

  if (typeof selectedData === 'string') {
    return selectedData.trim().length > 0;
  }

  return selectedData !== undefined && selectedData !== null;
};

const renderAlertTableByView = ({
  isMaiView,
  isFgCoverageView,
  isOpenPoDetailsView,
  isStockToNormView,
  TableComponent,
  TableComponent2,
  TableComponent3,
  TableComponent4,
  TableComponent5,
  alertDetailsData,
  state,
  alertType,
  viewType,
  handlePageChange,
  handleSortChange,
  sortConfig,
  isReadOnly,
  userInfo,
}) => {
  const commonTableProps = {
    data: alertDetailsData,
    columnList: state.columnList,
    loading: state.loading,
    subtotalFgCoverage: state.subtotalFgCoverage,
    subtotalPhysicalCoverage: state.subtotalPyshicalCoverage,
    weeklySubtotals: state.weeklySubtotals,
    paginationObj: state.paginationObj,
    onPageChange: handlePageChange,
    onSortChange: handleSortChange,
    sortConfig,
    isReadOnly,
  };

  if (isMaiView) {
    return (
      <TableComponent2
        data={alertDetailsData}
        columnList={state.columnList}
        type={alertType}
        viewType={viewType}
        loading={state.loading}
        paginationObj={state.paginationObj}
        perWeekMai={state.perWeekMai}
        perWeekMaiPhysical={state.perWeekMaiPhysical}
        totalStockToNorm={state.totalStockToNorm}
        subtotal={state.Subtotal}
        subtotalFgCoverage={state.subtotalFgCoverage}
        subtotalPhysicalCoverage={state.subtotalPyshicalCoverage}
        weeklySubtotals={state.weeklySubtotals}
        onPageChange={handlePageChange}
        onSortChange={handleSortChange}
        sortConfig={sortConfig}
        isReadOnly={isReadOnly}
      />
    );
  }

  if (isFgCoverageView) {
    return (
      <TableComponent3
        {...commonTableProps}
        perWeekMai={state.perWeekMai}
        perWeekMaiPhysical={state.perWeekMaiPhysical}
        type="FG Coverage"
      />
    );
  }

  if (isOpenPoDetailsView) {
    return (
      <TableComponent4
        {...commonTableProps}
        viewType={viewType}
        type={alertType}
      />
    );
  }

  if (isStockToNormView) {
    return (
      <TableComponent5
        {...commonTableProps}
        viewType={viewType}
        type="Norm Alert"
      />
    );
  }

  return (
    <TableComponent
      {...commonTableProps}
      viewType={viewType}
      type={alertType}
      userInfo={userInfo}
    />
  );
};

const AlertLanding = ({ alertType, isReadOnly }) => {
  const { kpiDetails: initialKpiDetails, uiConfig, apiConfig } = useMemo(
    () => getAlertConfig(alertType),
    [alertType]
  );

  const shouldUseContext = useMemo(
    () => CONTEXT_ALERT_TYPES.includes(alertType),
    [alertType]
  );

  const { accounts } = useMsal();
  const activeAccount = useMemo(() => accounts[0] || null, [accounts]);
  const [userInfo, setUserInfo] = useState(null);

  const [sortConfig, setSortConfig] = useState({ key: "", direction: "asc", week: null });

  const {
    alertDetailsData,
    setAlertDetailsData,
    selections
  } = useContext(SelectedAlertsContext);

  // Consolidated state
  const [state, setState] = useState({
    loading: true,
    exportLoader: false,
    initialLoad: true,
    drawerState: false,
    isDrawerOpen: false,
    filterDrawer: false,
    isKPIHide:false,
    openPopup: false,
    rmpmFilters: [],
    rmpmFiltersOption: {},
    currentPage: 1,
    paginationObj: INITIAL_PAGINATION,
    kpiObject: [],
    onClickStatus: '',
    columnList: [],
    perWeekMai: {},
    perWeekMaiPhysical: {},
    Subtotal:{},
    actionHistoryLoading: false,
    weeklySubtotals: {},
    subtotalFgCoverage: {},
    subtotalPyshicalCoverage: {},
    totalStockToNorm: 0
  });

  const [viewType, setViewType] = useState(() =>
    uiConfig.showToogleButton ? uiConfig.toggleBtn[0] : ''
  );
  const [groupByMaterialId, setGroupByMaterialId] = useState(false);

  const [snackBarObject, setSnackBarObject] = useState({
    snackbarOpen: false,
    message: '',
    type: 'error'
  });
  const [filterChangeCount, setFilterChangeCount] = useState(0);
  const [actionHistory, setActionHistory] = useState([]);
  const [actionHistoryPopupOpen, setActionHistoryPopupOpen] = useState(false);
  const latestFilters = useRef(state.rmpmFilters);
  const latestFilterOptions = useRef(state.rmpmFiltersOption);
  const fetchTimeoutRef = useRef(null);
  const clearFiltersRef = useRef(false);
  const [currentView] = useState('RMPM Alert');
  const { setCurrentSubPageLabel } = useRefresh();
  const controllerRef = useRef(null);
  const activeViewRef = useRef(viewType);

  const invalidateFilterCache = useCallback(() => {
    const usesViewTypeCache = ['MAI View', 'FG Coverage', 'Open PO Details', 'Stock to Norm'].includes(viewType);
    const cacheKey = `filterData_${usesViewTypeCache ? viewType : alertType}`;
    localStorage.removeItem(cacheKey);
  }, [alertType, viewType]);

  const getContractAlertMrpDefaultSelection = useCallback((filterOptions = latestFilterOptions.current) => {
    if (!CONTRACT_ALERT_MRP_DEFAULT_TYPES.has(alertType)) {
      return [];
    }

    const mrpOptions = filterOptions?.[CONTRACT_ALERT_MRP_FILTER_LABEL];
    if (!Array.isArray(mrpOptions)) {
      return [];
    }

    return mrpOptions.filter(option => !CONTRACT_ALERT_MRP_EXCLUDED_OPTIONS.has(String(option).trim()));
  }, [alertType]);

  const applyContractAlertMrpDefault = useCallback((filters = [], filterOptions = latestFilterOptions.current, insertIfMissing = false) => {
    const safeFilters = Array.isArray(filters) ? filters : [];
    const defaultSelection = getContractAlertMrpDefaultSelection(filterOptions);

    if (!CONTRACT_ALERT_MRP_DEFAULT_TYPES.has(alertType) || defaultSelection.length === 0) {
      return safeFilters;
    }

    let foundMrpFilter = false;

    const normalizedFilters = safeFilters.map(filter => {
      if (filter.label !== CONTRACT_ALERT_MRP_FILTER_LABEL) {
        return filter;
      }

      foundMrpFilter = true;
      return hasSelectedValues(filter.selectedData)
        ? filter
        : { ...filter, selectedData: defaultSelection };
    });

    if (!foundMrpFilter && insertIfMissing) {
      return [
        ...normalizedFilters,
        { label: CONTRACT_ALERT_MRP_FILTER_LABEL, selectedData: defaultSelection }
      ];
    }

    return normalizedFilters;
  }, [alertType, getContractAlertMrpDefaultSelection]);

  // Memoized computations
  const selectedRecomLength = useMemo(() => {
    const mapping = {
      'RMPM Alert': selections.rmpm?.accepted?.length,
      'Contract Alert': selections.contract?.accepted?.length,
      'Agile OR': selections.agileOr?.accepted?.length
    };
    return mapping[alertType] || 0;
  }, [selections, alertType]);

  const rejectedCount = useMemo(() => {
    const mapping = {
      'RMPM Alert': selections.rmpm?.rejected?.length,
      'Contract Alert': selections.contract?.rejected?.length,
      'Agile OR': selections.agileOr?.rejected?.length
    };
    return mapping[alertType] || 0;
  }, [selections, alertType]);

  const kpiData = useMemo(() => {
    if (!Array.isArray(state.kpiObject) || !Array.isArray(initialKpiDetails)) return [];

    const statusLabels = new Set(['Alert Status', 'Segmentation', 'FG Coverage', 'FG Coverage (Priority)',
      'Prioritization', 'Root cause loss tree', 'Stock to Norm', 'Contract coverage %']);

    return initialKpiDetails.map(configItem => {
      const apiItem = state.kpiObject.find(k =>
        k.label === configItem.label || k.label1 === configItem.label
      );
      if (!apiItem && alertType!=='RMPM Alert') return configItem;

      if (apiItem?.label1 || apiItem?.label2) {
        return { ...configItem, ...apiItem };
      }

      if (statusLabels.has(configItem.label) && apiItem?.values) {
        return { ...configItem, values: apiItem.values };
      }
      if(apiItem){
      return { ...configItem, value: apiItem.value };
      }
    });
  }, [state.kpiObject, initialKpiDetails]);

  const TableComponent = useMemo(() => apiConfig.tableComponent, [apiConfig.tableComponent]);
  const TableComponent2 = useMemo(() => apiConfig.tableComponent2, [apiConfig.tableComponent2]);
  const TableComponent3 = useMemo(() => apiConfig.tableComponent3, [apiConfig.tableComponent3]);
  const TableComponent4=useMemo(() => apiConfig.tableComponent4,[apiConfig.tableComponent4]);
  const TableComponent5=useMemo(() => apiConfig.tableComponent5,[apiConfig.tableComponent5]);
  const showActionHistory = uiConfig?.showActionHistory && viewType !== 'MAI View' && viewType !== 'FG Coverage' && viewType!== 'Open PO Details' && viewType!== 'Stock to Norm';
  const trackableViews = ['MAI View', 'FG Coverage', 'Open PO Details', 'Stock to Norm'];
  const trackedViewType = trackableViews.includes(viewType) ? viewType : null;

  usePageTracking(trackedViewType);

  // Optimized filter data fetching
  const filterData = useCallback(
    () => getFilterDetails(alertType, viewType, activeAccount?.username, transformFilters(latestFilters.current)),
    [alertType, viewType, activeAccount?.username]
  );

  // Optimized payload generation
  const generatePayload = useCallback((page, perPage, clearFilters = false, filters = latestFilters.current, filterOptions = latestFilterOptions.current, shouldGroupByMaterialId = false) => {
    const normalizedFilters = applyContractAlertMrpDefault(filters, filterOptions, true);
    const transformedFilters = transformFilters(normalizedFilters);
    
    // Determine the type based on viewType
    let type = alertType;
    if (viewType === 'MAI View') {
      type = 'MAI';
    } else if (viewType === 'FG Coverage') {
      type = 'FG Coverage';
    } else if (viewType === 'Open PO Details') {
      type = 'OpenPO Details';
    } else if (viewType === 'Stock to Norm') {
      type = 'Norm Alert';
    }
    
    return {
      email: activeAccount?.username,
      type: type,
      role: activeAccount?.idTokenClaims?.roles,
      page,
      per_page: perPage,
      clearFilters,
      filterData: transformedFilters,
      sortBy: sortConfig?.key || "",
      sortOrder: sortConfig?.direction || "asc",
      week: sortConfig?.week || null,
      ...((viewType === 'Open PO Details' ||
        ['Contract Alert', 'Contract PR2 Alert'].includes(alertType) ||
        (alertType === 'RMPM Alert' && ['Detailed', 'Detailed view', 'MAI View'].includes(viewType)))
        ? { groupByMaterialId: shouldGroupByMaterialId === true }
        : {}),
    };
  }, [alertType, viewType, activeAccount, sortConfig, applyContractAlertMrpDefault]);

  // Validation function for API response based on view type
  const validateResponseForView = (response, view) => {
    if (!response) return false;

    // // For MAI View and FG Coverage, check for weekly data structure
    if (view === 'MAI View') {
      const isValid = (
        response.perWeekMai &&
        typeof response.perWeekMai === 'object'
      );
      return isValid;
    }

    else if (view === 'FG Coverage') {
      const isValid = (
        response.subtotalFgCoverage &&
        typeof response.subtotalFgCoverage === 'object' &&
        response.subtotalPyshicalCoverage &&
        typeof response.subtotalPyshicalCoverage === 'object'
      );
      return isValid;
    }

    // For Detailed view, check for array data
    if (view === 'Detailed' || view==='Open PO Details' || view==='Stock to Norm') {
      const isValid = Array.isArray(response.alertDetails);
      return isValid;
    }

    return true;
  };

  // Optimized data fetching
  const fetchData = useCallback(async () => {
    // Cancel any pending request
    if (controllerRef.current) {
      controllerRef.current.abort();
    }

    controllerRef.current = new AbortController();
    const currentView = activeViewRef.current;
    const clearFiltersRequested = clearFiltersRef.current;
    // Consume as one-shot flag for this API call only.
    clearFiltersRef.current = false;

    try {
      setState(prev => ({ ...prev, loading: true }));

      const filterResponse = await filterData();
      const filterOptions = filterResponse?.data?.filters || {};
      const normalizedRequestFilters = applyContractAlertMrpDefault(latestFilters.current, filterOptions, true);
      const dataResponse = await apiConfig.apiFunction(
        generatePayload(
          state.currentPage,
          state.paginationObj.per_page,
          clearFiltersRequested && !normalizedRequestFilters.some(filter => hasSelectedValues(filter?.selectedData)),
          normalizedRequestFilters,
          filterOptions,
          groupByMaterialId
        ),
        {
          signal: controllerRef.current.signal
        }
      );

      // Only update state if the view hasn't changed
      if (currentView !== activeViewRef.current) {
        console.log(`View changed from ${currentView} to ${activeViewRef.current}, discarding response`);
        return;
      }

      // Validate response format based on view type
      const isValidResponse = validateResponseForView(dataResponse, currentView);
      if (!isValidResponse) {
        console.error(`Invalid response format for view: ${currentView}`);
        return;
      }

      if (shouldUseContext) {
        setAlertDetailsData(dataResponse?.alertDetails || []);
      }

      const normalizedResponseFilters = applyContractAlertMrpDefault(dataResponse?.filters || [], filterOptions);

      setState(prev => ({
        ...prev,
        rmpmFilters: normalizedResponseFilters,
        rmpmFiltersOption: filterOptions,
        loading: false,
        exportLoader: false,
        initialLoad: false,
        columnList: dataResponse?.defaultColumns || [],
        perWeekMai: dataResponse?.perWeekMai || {},
        perWeekMaiPhysical: dataResponse?.perWeekMaiPhysical || {},
        totalStockToNorm: dataResponse?.totalStockToNorm|| 0,
        Subtotal:dataResponse?.Subtotal || {},
        weeklySubtotals: dataResponse?.weeklySubtotals || {},
        paginationObj: {
          page: dataResponse?.pagination?.page || 1,
          per_page: prev.paginationObj.per_page,
          total: dataResponse?.pagination?.total || 0
        },
        subtotalFgCoverage: dataResponse?.subtotalFgCoverage || {},
        subtotalPyshicalCoverage: dataResponse?.subtotalPyshicalCoverage || {},
        kpiObject: dataResponse?.KPIObject?.KPIs || []
      }));

    } catch (error) {
      // Ignore abort errors
      if (error.name === 'AbortError') {
        console.log('Request aborted');
        return;
      }

      setSnackBarObject({
        snackbarOpen: true,
        message: "An error occurred while fetching data. Please refresh or try again",
        type: 'error'
      });
      setState(prev => ({ ...prev, loading: false, initialLoad: false }));
    }
  }, [apiConfig, filterData, generatePayload, shouldUseContext, setAlertDetailsData, state.currentPage, state.paginationObj.per_page, applyContractAlertMrpDefault, groupByMaterialId]);

  useEffect(() => {
    setGroupByMaterialId(false);
  }, [viewType]);

  const handleGroupByMaterialIdChange = useCallback((nextValue) => {
    setGroupByMaterialId(nextValue === true);
    setState((prev) => ({
      ...prev,
      currentPage: 1,
      paginationObj: { ...prev.paginationObj, page: 1 },
    }));
  }, []);

  useEffect(() => {
    setCurrentSubPageLabel(currentView);
    return () => {
      setCurrentSubPageLabel('');
    };
  }, [currentView, setCurrentSubPageLabel]);

  // Effects
  useEffect(() => {
    scheduleCleanup();
  }, []);

  useEffect(() => {
    latestFilters.current = state.rmpmFilters;
  }, [state.rmpmFilters]);

  useEffect(() => {
    latestFilterOptions.current = state.rmpmFiltersOption;
  }, [state.rmpmFiltersOption]);

  useEffect(() => {
    if (fetchTimeoutRef.current) {
      clearTimeout(fetchTimeoutRef.current);
    }

    fetchTimeoutRef.current = setTimeout(() => {
      fetchData();
    }, 300);

    return () => {
      if (fetchTimeoutRef.current) {
        clearTimeout(fetchTimeoutRef.current);
      }
    };
  }, [fetchData, filterChangeCount, viewType, sortConfig]);

  useEffect(() => {
    activeViewRef.current = viewType;

    // Cleanup function to abort on unmount or view change
    return () => {
      if (controllerRef.current) {
        controllerRef.current.abort();
      }
    };
  }, [viewType]);

  useEffect(()=>{
    const users_info=localStorage.getItem('UserInfo');
    const parsedUserInfo=JSON.parse(users_info)
    setUserInfo({accessType:parsedUserInfo?.user_info?.accessType,
       persona:parsedUserInfo?.user_info?.persona,
       scope:parsedUserInfo?.user_info?.scope
    })
    
  },[])

  // Event handlers
  const handleMultiSelectChange = useCallback((label, values) => {
    setState(prev => {
      const updatedFilters = prev.rmpmFilters.map(filter =>
        filter.label === label ? { ...filter, selectedData: values } : filter
      );

      const hasSelection = updatedFilters.some(filter => hasSelectedValues(filter?.selectedData));

      // If no filters remain selected (e.g., eraser cleared the last selected filter),
      // mark next API request as clearFilters=true.
      clearFiltersRef.current = !hasSelection;

      return {
        ...prev,
        rmpmFilters: updatedFilters,
      };
    });
    setFilterChangeCount(prev => prev + 1);
    setSortConfig({ key: "", direction: "asc", week: null });
  }, []);

  const exportToExcel = useCallback(async () => {
    try {
      setState(prev => ({ ...prev, exportLoader: true }));
      
      // Determine the type based on viewType
      let type = alertType;
      if (viewType === 'MAI View') {
        type = 'MAI View';
      } else if (viewType === 'FG Coverage') {
        type = 'FG Coverage';
      } else if (viewType === 'Open PO Details') {
        type = 'OpenPO Details';
      } else if (viewType === 'Stock to Norm') {
        type = 'Norm Alert';
      }
      
      const transformedFilters = transformFilters(latestFilters.current);

      await exportExcelFile({
        type,
        filters: transformedFilters,
        email: activeAccount?.username,
      });
    } catch (error) {
      setSnackBarObject({ snackbarOpen: true, message: error.message, type: 'error' });
    } finally {
      setState(prev => ({ ...prev, exportLoader: false }));
    }
  }, [alertType, viewType, activeAccount?.username]);


  const handleActionSummaryPopup = useCallback(async () => {
    try {
      setState(prev => ({ ...prev, actionHistoryLoading: true }));
      const data = await getActionSummary(alertType);
      setActionHistory(data);
      setActionHistoryPopupOpen(true);
    } catch (error) {
      setSnackBarObject({ snackbarOpen: true, message: error.message, type: 'error' });
    } finally {
      setState(prev => ({ ...prev, actionHistoryLoading: false }));
    }
  }, [alertType]);

  const handleUnderlyingDataPopup = useCallback(async () => {
    try {
      setState(prev => ({ ...prev, exportLoader: true }));
      await underLyingExportData({
        alertType,
      });
    } catch (error) {
      setSnackBarObject({ snackbarOpen: true, message: error.message, type: 'error' });
    } finally {
      setState(prev => ({ ...prev, exportLoader: false }));
    }
  }, [alertType]);

  const toggleDrawer = useCallback((open) => () => {
    if (selectedRecomLength === 0) return;
    setState(prev => ({ ...prev, drawerState: open }));
  }, [selectedRecomLength]);

  const handleStatusClick = useCallback((status) => {
    setState(prev => ({ ...prev, openPopup: true, onClickStatus: status }));
  }, []);

  const handleAlertAccept = useCallback((count, status) => {
    setState(prev => ({
      ...prev,
      kpiObject: prev.kpiObject.map(kpi => {
        if (kpi.label === "Alert Status" && kpi.values) {
          return {
            ...kpi,
            values: {
              ...kpi.values,
              [status]: (kpi.values[status] || 0) + count,
            }
          };
        }
        return kpi;
      })
    }));

    invalidateFilterCache();

    // In Detailed views, refresh data so filters are recalculated after accept/reject.
    if (viewType.includes('Detailed')) {
      setFilterChangeCount(prev => prev + 1);
    }
  }, [viewType, invalidateFilterCache]);

  const handleDrawerToggle = useCallback((drawerType) => {
    setState(prev => ({ ...prev, [drawerType]: !prev[drawerType] }));
  }, []);

  const columnCustomization = useCallback((list) => {
    setState(prev => ({ ...prev, columnList: list, isDrawerOpen: false }));
    fetchData();
  }, [fetchData]);

  const closeSnackbar = useCallback(() => {
    setSnackBarObject({ message: '', snackbarOpen: false, type: 'error' });
  }, []);

  const handleToggleBtnChange = useCallback((event, newViewType) => {
    if (newViewType !== null) {
      setViewType(newViewType);
      setAlertDetailsData([]);
      setCurrentSubPageLabel(newViewType);

      // Reset pagination to page 1 on tab change
      setState(prev => ({
        ...prev,
        currentPage: 1,
        paginationObj: {
          ...prev.paginationObj,
          page: 1,
          per_page: INITIAL_PAGINATION.per_page
        }
      }));
    }
  }, [setAlertDetailsData, setCurrentSubPageLabel]);

  const resetFilter = useCallback(() => {
    setState(prev => {
      const contractAlertMrpDefault = getContractAlertMrpDefaultSelection();
      const resetFilters = prev.rmpmFilters.map(filter => {
        if (filter.label === 'PO Ageing') {
          return { ...filter, selectedData: ['N-7 Ageing PO'] };
        }

        if (CONTRACT_ALERT_MRP_DEFAULT_TYPES.has(alertType) && filter.label === CONTRACT_ALERT_MRP_FILTER_LABEL) {
          return { ...filter, selectedData: contractAlertMrpDefault };
        }

        return { ...filter, selectedData: [] };
      });

      clearFiltersRef.current = !resetFilters.some(filter => hasSelectedValues(filter?.selectedData));

      return {
        ...prev,
        rmpmFilters: resetFilters,
        currentPage: 1,
        paginationObj: {
          ...INITIAL_PAGINATION,
          page: 1
        }
      };
    });
    setFilterChangeCount(prev => prev + 1);
    setSortConfig({ key: "", direction: "asc", week: null });
  }, [alertType, getContractAlertMrpDefaultSelection]);

  const handlePageChange = useCallback((newPage, perPage) => {
    setState(prev => ({
      ...prev,
      currentPage: newPage,
      paginationObj: {
        ...prev.paginationObj,
        page: newPage,
        per_page: perPage || prev.paginationObj.per_page
      }
    }));
  }, []);

  const handleFiltersSaved = useCallback((updatedFilters) => {
    const hasSelection = updatedFilters.some(filter => hasSelectedValues(filter?.selectedData));

    clearFiltersRef.current = !hasSelection;
    setState(prev => ({ ...prev, rmpmFilters: updatedFilters }));
    setFilterChangeCount(prev => prev + 1);
    setSortConfig({ key: "", direction: "asc", week: null });
  }, []);

  const handleSortChange = useCallback((newSortConfig) => {
    setSortConfig(newSortConfig);
    setState(prev => ({ ...prev, currentPage: 1 }));
  }, []);

  // Memoized filter chips
  const filterChips = useMemo(
    () => buildFilterChips(state.rmpmFilters, handleMultiSelectChange),
    [state.rmpmFilters, handleMultiSelectChange]
  );

  // Memoized overflow menu items
  const overflowMenuItems = useMemo(() => [
    {
      label: 'Hide KPI Tiles',
      icon: EyeOpen,
      onClick: () => handleDrawerToggle('isKPIHide'),
    },
    {
      label: 'More Filters',
      icon: Filters,
      onClick: () => handleDrawerToggle('filterDrawer'),
    },
    {
      label: 'Customise',
      icon: Slider,
      onClick: () => handleDrawerToggle('isDrawerOpen'),
    },
    {
      label: 'Export',
      icon: Excel,
      onClick: () => {
        void exportToExcel();
      },
    },
    ...(showActionHistory ? [{
      label: 'Action History',
      icon: <HistoryIcon />,
      onClick: handleActionSummaryPopup,
    }] : []),
    ...(uiConfig.showUnderlyingData ? [{
      label: 'Underlying Data',
      icon: Excel,
      onClick: handleUnderlyingDataPopup,
    }] : []),
    ...(pages.includes(alertType === 'RMPM Alert' ? viewType : alertType) ? [{
      label: groupByMaterialId ? 'Grouped by material' : 'Group by material',
      onClick: () => handleGroupByMaterialIdChange(!groupByMaterialId),
      sx: {
        minHeight: '30px',
        margin: '4px 8px',
        borderRadius: '4px',
        border: groupByMaterialId ? '1px solid #1F36C7' : '1px solid rgba(31, 54, 199, 0.5)',
        color: groupByMaterialId ? '#FFFFFF' : '#1F36C7',
        backgroundColor: groupByMaterialId ? '#1F36C7' : '#FFFFFF',
        '&:hover': {
          backgroundColor: groupByMaterialId ? '#1F36C7' : '#EEF2FF',
        },
      },
    }] : []),
  ], [
    handleDrawerToggle,
    alertType,
    viewType,
    groupByMaterialId,
    handleGroupByMaterialIdChange,
    exportToExcel,
    handleActionSummaryPopup,
    handleUnderlyingDataPopup,
    showActionHistory,
    uiConfig.showUnderlyingData,
  ]);

  // Render loading state
  if (state.loading && state.initialLoad) {
    return <div className={styles.loaderContainer}><CircularProgress /></div>;
  }

  const containerClass = getContainerClass(viewType, uiConfig);
  const tableBodyClass = getTableBodyClass(alertType, viewType);
  const isMaiView = viewType === 'MAI View';
  const isFgCoverageView = viewType === 'FG Coverage';
  const isOpenPoDetailsView = viewType === 'Open PO Details';
  const isStockToNormView = viewType === 'Stock to Norm';
  const showFooter = uiConfig.showFooter && !viewType.includes('MAI') && !viewType.includes('Open');
  const customizeType = getCustomizeType(viewType, alertType);
  const exportLoaderType = alertType === 'RMPM Alert' ? viewType : alertType;

  const handleTableHeight = (viewType, alertType) =>{
    if((viewType === 'Detailed view' || viewType === 'FG Coverage' || viewType === 'Stock to Norm')) return '5vh';
    else if (alertType === 'Contract Alert') return '9vh';
    else if (alertType === 'Agile OR') return '5vh'
    return 0;
  }
  return (
    <>
      <div className={styles.alertPageScroll} style={{paddingBottom : handleTableHeight(viewType, alertType)}}>
        {uiConfig.showKPI && !state["isKPIHide"] && (
          <div className={styles.kpiContainer}>
            <AlertRmpmKpi KPIObj={kpiData} type={alertType} />
          </div>
        )}

        <div className={containerClass}>
          <div className={tableBodyClass}>
            <div className={styles.filters}>
              {state.rmpmFilters
                .filter(filter => filter.isFavourite)
                .sort((a, b) => a.DisplayOrder - b.DisplayOrder)
                .map(filter => (
                  <ListItem key={filter.label} className={styles.listCustomClass}>
                    <Multiselectwithsearchinput
                      label={filter.label}
                      options={state.rmpmFiltersOption[filter.label]}
                      filterValues={filter.selectedData}
                      handleFilter={handleMultiSelectChange}
                      disabled={false}
                      type={alertType}
                      defaultValue={CONTRACT_ALERT_MRP_DEFAULT_TYPES.has(alertType) && filter.label === CONTRACT_ALERT_MRP_FILTER_LABEL ? getContractAlertMrpDefaultSelection() : null}
                    />
                  </ListItem>
                ))}

              <div style={{ paddingRight: '5px', display: 'flex', alignItems: 'center', columnGap: '10px' }}>
                <Tooltip title={state.isKPIHide ? "Show KPI Tiles" : "Hide KPI Tiles"} placement="top"
                  slotProps={{
                    tooltip: {
                      sx: {
                        color: "#000000",
                        backgroundColor: "#fff",
                      },
                    },
                  }}
                >
                  <button
                    type="button"
                    onClick={() => handleDrawerToggle('isKPIHide')}
                    style={{ border: 'none', background: 'transparent', padding: 0, cursor: 'pointer' }}
                    aria-label="Hide KPI Tiles"
                  >
                    <img src={state.isKPIHide ? EyeClose : EyeOpen} alt="Hide KPI Tiles" width={20} height={20} style={{ margin: '4px 2px 0 0' }} />
                  </button>
                </Tooltip>
                <button
                  type="button"
                  onClick={resetFilter}
                  style={{ border: 'none', background: 'transparent', padding: 0, margin: 0, cursor: 'pointer' }}
                  aria-label="Reset Filters"
                >
                  <img src={resetBtn} alt="Reset Filters"/>
                </button>
                <OverflowMenu menuItems={overflowMenuItems} />
              </div>
            </div>

            <div className={styles.filtersBtnContainer}>
              <Box className={styles.chipContainer}>
                {filterChips.map(chip => (
                  <Chip key={chip.key} label={chip.label} onDelete={chip.onDelete} />
                ))}
              </Box>
            </div>

            <div style={{ display: 'flex', justifyContent: 'right', alignItems: 'center' }}>
              {uiConfig.showToogleButton && (
                <div className={styles.toggleBtnContainer}>
                  <StyledToggleButtonGroup
                    color="primary"
                    value={viewType}
                    exclusive
                    onChange={handleToggleBtnChange}
                    aria-label="Platform"
                    size="small"
                  >
                    {uiConfig.toggleBtn.map((details) => (
                      <ToggleButton key={details} value={details}>
                        {details}
                      </ToggleButton>
                    ))}
                  </StyledToggleButtonGroup>
                </div>
              )}
            </div>

            {isMaiView ? (
              <TableComponent2
                groupByMaterialId={groupByMaterialId}
                data={alertDetailsData}
                columnList={state.columnList}
                type={alertType}
                viewType={viewType}
                loading={state.loading}
                paginationObj={state.paginationObj}
                perWeekMai={state.perWeekMai}
                perWeekMaiPhysical={state.perWeekMaiPhysical}
                totalStockToNorm={state.totalStockToNorm}
                subtotal={state.Subtotal}
                subtotalFgCoverage={state.subtotalFgCoverage}
                subtotalPhysicalCoverage={state.subtotalPyshicalCoverage}
                weeklySubtotals={state.weeklySubtotals}
                onPageChange={handlePageChange}
                onSortChange={handleSortChange}
                sortConfig={sortConfig}
                isReadOnly={isReadOnly}
              />
            ) : isFgCoverageView ? (
              <TableComponent3
                data={alertDetailsData}
                columnList={state.columnList}
                type="FG Coverage"
                loading={state.loading}
                paginationObj={state.paginationObj}
                perWeekMai={state.perWeekMai}
                perWeekMaiPhysical={state.perWeekMaiPhysical}
                subtotalFgCoverage={state.subtotalFgCoverage}
                subtotalPhysicalCoverage={state.subtotalPyshicalCoverage}
                weeklySubtotals={state.weeklySubtotals}
                onPageChange={handlePageChange}
                onSortChange={handleSortChange}
                sortConfig={sortConfig}
                isReadOnly={isReadOnly}
              />
            ) : isOpenPoDetailsView ? (
                <TableComponent4 
                data={alertDetailsData}
                columnList={state.columnList}
                viewType={viewType}
                type={alertType}
                loading={state.loading}
                subtotalFgCoverage={state.subtotalFgCoverage}
                subtotalPhysicalCoverage={state.subtotalPyshicalCoverage}
                weeklySubtotals={state.weeklySubtotals}
                paginationObj={state.paginationObj}
                onPageChange={handlePageChange}
                onSortChange={handleSortChange}
                sortConfig={sortConfig}
                isReadOnly={isReadOnly}
                groupByMaterialId={groupByMaterialId}
                onGroupByMaterialIdChange={handleGroupByMaterialIdChange}
                />
              ) : isStockToNormView ? (
                <TableComponent5
                data={alertDetailsData}
                columnList={state.columnList}
                viewType={viewType}
                type="Norm Alert"
                loading={state.loading}
                subtotalFgCoverage={state.subtotalFgCoverage}
                subtotalPhysicalCoverage={state.subtotalPyshicalCoverage}
                weeklySubtotals={state.weeklySubtotals}
                paginationObj={state.paginationObj}
                onPageChange={handlePageChange}
                onSortChange={handleSortChange}
                sortConfig={sortConfig}
                isReadOnly={isReadOnly}
                />
            ) : (
              <TableComponent
                groupByMaterialId={groupByMaterialId}
                data={alertDetailsData}
                columnList={state.columnList}
                viewType={viewType}
                type={alertType}
                loading={state.loading}
                subtotalFgCoverage={state.subtotalFgCoverage}
                subtotalPhysicalCoverage={state.subtotalPyshicalCoverage}
                weeklySubtotals={state.weeklySubtotals}
                paginationObj={state.paginationObj}
                onPageChange={handlePageChange}
                onSortChange={handleSortChange}
                sortConfig={sortConfig}
                isReadOnly={isReadOnly}
                userInfo={userInfo}
              />
            )}
          </div>
        </div>
      </div>

      {snackBarObject.snackbarOpen && (
        <SnackBarMessage
          type={snackBarObject.type}
          snackbarMessage={snackBarObject.message}
          snackbarOpen={snackBarObject.snackbarOpen}
          setSnackbarOpen={closeSnackbar}
        />
      )}

      {showFooter && (
        <div className={styles.rmpmFooter}>
          <div className={styles.btnContainer}>
            {uiConfig.showReviewCart && (
              <CustomButton
                label="Review Cart"
                type="cart"
                disabled={isReadOnly || selectedRecomLength === 0}
                onClick={toggleDrawer(true)}
              />
            )}
            {uiConfig.showAcceptButton && (
              <CustomButton
                label="Accept"
                count={selectedRecomLength}
                type="submit"
                disabled={isReadOnly || selectedRecomLength === 0}
                onClick={() => handleStatusClick('Accepted')}
              />
            )}
            {uiConfig.showRejectButton && (
              <CustomButton
                label="Reject"
                count={rejectedCount}
                type="submit"
                disabled={isReadOnly || rejectedCount === 0}
                onClick={() => handleStatusClick('Rejected')}
              />
            )}
            {uiConfig.showSubmitButton && (
              <CustomButton
                label="Submit"
                count={selectedRecomLength}
                type="submit"
                disabled={isReadOnly || selectedRecomLength === 0}
                onClick={() => handleStatusClick('')}
              />
            )}
          </div>
        </div>
      )}

      {uiConfig.showReviewCart && (
        <Drawer
          anchor="right"
          open={state.drawerState}
          onClose={toggleDrawer(false)}
          sx={{ '& .MuiDrawer-paper': { width: "75%" } }}
        >
          <ReviewCart
            onClose={toggleDrawer(false)}
            type={alertType}
            onAccept={(count, status) => handleAlertAccept(count, status)}
          />
        </Drawer>
      )}

      {uiConfig.showActionPopup && (
        <ActionPopup
          open={state.openPopup}
          onClose={() => setState(prev => ({ ...prev, openPopup: false }))}
          type={alertType}
          status={state.onClickStatus}
          onAccept={(count) => handleAlertAccept(count, state.onClickStatus)}
        />
      )}

      {uiConfig.showCustomizeColumns && state.isDrawerOpen && (
        <CustomiseColumns
          anchor="right"
          columns={state.columnList}
          isOpen={state.isDrawerOpen}
          handleCustomizeDrawer={() => handleDrawerToggle('isDrawerOpen')}
          columnCustomization={columnCustomization}
          username={activeAccount?.username}
          type={customizeType}
        />
      )}

      {uiConfig.showMoreFilters && state.filterDrawer && (
        <MoreFilters
          anchor="right"
          filterDrawer={state.filterDrawer}
          handleFilterDrawer={() => handleDrawerToggle('filterDrawer')}
          rmpmFilters={state.rmpmFilters}
          setRmpmFilters={(filters) => setState(prev => ({ ...prev, rmpmFilters: filters }))}
          username={activeAccount?.username}
          type={alertType}
          viewType={viewType}
          options={state.rmpmFiltersOption}
          onFiltersSaved={handleFiltersSaved}
        />
      )}

      {uiConfig?.showChatBot && <ChatBot />}
      {state.exportLoader && <ExportLoader type={exportLoaderType} />}

      {showActionHistory && (
        <ActionSummaryPopup
          type={alertType}
          actionHistory={actionHistory}
          open={actionHistoryPopupOpen}
          onClose={() => setActionHistoryPopupOpen(false)}
          loading={state.actionHistoryLoading}
        />
      )}

    </>
  );
}

AlertLanding.propTypes = {
  alertType: PropTypes.oneOf(['RMPM Alert', 'Norm Alert', 'Contract Alert', 'Contract PR2 Alert', 'Agile OR', 'FG Coverage']).isRequired,
  isReadOnly: PropTypes.bool
};

export default React.memo(AlertLanding);